import React from "react";
import { FaShareAlt } from "react-icons/fa";
import { toast } from "react-toastify";

const ShareComponent = ({ url, text, title }) => {
  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({ title, text, url });
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(url);
        toast.success("Link copied to clipboard");
      } else {
        // Fallback: open native prompt to copy
        const input = document.createElement("input");
        input.value = url;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        toast.success("Link copied to clipboard");
      }
    } catch (err) {
      console.error("Share failed:", err);
      toast.error("Unable to share");
    }
  };

  return (
    <div className="d-flex mt-3">
      <button
        onClick={handleShare}
        className="btn btn-outline-primary text-white d-flex align-items-center gap-2"
        aria-label="Share"
        title="Share"
      >
        <FaShareAlt size={18} />
        <span className="d-none d-md-inline">Share</span>
      </button>
    </div>
  );
};

export default ShareComponent;
